import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import routes from "./routes/routes";
import ThemeProvider from "./theme/ThemeProvider";

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <AppRoutes routes={routes} />
      </Router>
    </ThemeProvider>
  );
};

export default App;
